import { Injectable } from "@angular/core";
import { AuthService, AuthType } from "./auth.service";
import { Observable } from "rxjs/internal/Observable";
import { Addon } from "../models/addon.model";
import { ExdrLanguageService } from "../../languages/services/exdr-language.service";
import { TabKeyEnum } from "../enums/tab-key-enum";
import { SharedService } from "../shared.service";
import { TranslateService } from "@ngx-translate/core";
import { map } from "rxjs/operators";

@Injectable({
  providedIn: "root",
})
export class GroupLabelService {
  constructor(
    private authService: AuthService,
    private langService: ExdrLanguageService,
    private sharedService: SharedService,
    private translate: TranslateService
  ) { }

  getTabTranslation(key: TabKeyEnum | string): Observable<string> {
    return this.authService.getAddonsAuth(this.authService.idenediGroupId).pipe(
      map((addons) => {

        return this._getTabTranslation(key, addons);
      })
    );
  }

  private _getTabTranslation(tabKey: string, addons: Addon[]) {
    let title = "";
    if (!tabKey) {
      return title;
    }
    const tabs = this.sharedService.getHeaderTabs({ key: tabKey });
    if (tabs.length) {
      title = tabs[0].name;
    } else {
      let customTab = addons.find(
        (addon) => addon.InstanceId == tabKey.replace("custom tab", "")
      );
      if (!customTab) {
        customTab = addons.find(
          (addon) => addon.InstanceId == tabKey.replace("footer tab", "")
        );
        if (!customTab) {
          customTab = addons.find(
            (addon) => addon?.PublicProperties?.urlName == tabKey
          );
        }
      }
      if (customTab) {
        title = customTab.PublicProperties?.name ?? title;
      }
    }
    const tabOrderAddon = addons.find(
      (addon) => addon.Type.toLowerCase() == AuthType.TabOrder.toLowerCase()
    );
    let tabOrderitems = tabOrderAddon?.PublicProperties?.jsonData?.data || [];
    const utilityTabOrderitems = tabOrderAddon?.PublicProperties?.jsonData?.utilities || [];
    const footerTabOrderItems = tabOrderAddon?.PublicProperties?.jsonData?.footer || [];
    tabOrderitems = tabOrderitems.concat(utilityTabOrderitems).concat(footerTabOrderItems);
    const itemOrder = tabOrderitems.find((t) => t.key === tabKey);
    if (itemOrder) {
      title = itemOrder?.name;
    }

    const langAddon = addons.find(
      (a) => a.Type.toLowerCase() == AuthType.GroupLanguages.toLowerCase()
    );
    let langData = langAddon?.PublicProperties?.jsonData;
    const locales = Object.keys(langData ?? {});
    if (!locales?.length) {
      return title;
    }
    let currentLang = langData[this.langService.currentLanguage?.locale];
    if (currentLang?.settings?.isEnable == "1") {
      let key = tabKey.replace("custom tab", "");
      if (tabKey.startsWith("footer")) {
        key = tabKey.replace("footer tab", "");
      }
      const tabData = currentLang[key];
      if (tabData) {
        /**
         * tabData has following structure
         * isEnable: "0"
          name: "الكهرباء"
          topic: {id: '', name: '', slug: ''}
          url: ""
         */
        title = tabData.name?.length ? tabData.name : title;
      }
    }
    return title;
  }

  getLocaleData(locale: string) {
    return this.authService.getAddonsAuth(this.authService.idenediGroupId).pipe(
      map((addons) => {
        const langAddon = addons.find(
          (a) => a.Type.toLowerCase() == AuthType.GroupLanguages.toLowerCase()
        );
        let langData = langAddon?.PublicProperties?.jsonData;
        const locales = Object.keys(langData ?? {});
        if (!locales?.length || !locales?.includes(locale)) {
          return null;
        }
        return langData[this.langService.currentLanguage?.locale] ?? null;
      })
    );
  }

  getLanguageData(languageDropDownDisplay) {
    return this.authService.getAddonsAuth(this.authService.idenediGroupId).pipe(
      map((addons) => {
        const groupLanguageAddon = addons.find(
          (addon) => addon.Type === AuthType.GroupLanguages
        );
        if (groupLanguageAddon) {
          let langData = groupLanguageAddon?.PublicProperties?.jsonData;
          let languagesArray = Object.keys(langData).map(function (
            personNamedIndex
          ) {
            let person = langData[personNamedIndex];
            return person;
          });
          if (languagesArray.filter(la => la.settings?.isEnable === '1').length > 1) {
            languageDropDownDisplay = true;
          }
        }
        return languageDropDownDisplay;
      })
    );
  }

  getTabLocaleData(tabKey: string, locale: string) {
    return this.getLocaleData(locale).pipe(map(localeData => {
      if (!localeData) { return null }
      return localeData[tabKey] ?? null;
    }))
  }
}
